/**
 * This is an overview page, summarizing the informations for recent conversations, as well as the current quota state
 *
 * @format
 */

import React, { useEffect } from 'react';
import { deleteAllCookies } from './cookieHelper/cookieHelper';
//import 'https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css';
//import 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.8.1/font/bootstrap-icons.css';
export function Header() {
  const [userName, setUserName] = React.useState('');
  const [image, setImage] = React.useState<string>();
  //const [isOk, setResponse] = React.useState();

  useEffect(() => {}, []);

  return (
    <div
      style={{
        height: '20px',
        margin: '0px',
        padding: '0px',
      }}
    >
      <button
        type='button'
        title='startoverbutton'
        style={{ font: 'normal normal normal 14px/1 FontAwesome !important' }}
        className='fa fa-refresh'
        onClick={() => {
          deleteAllCookies.then(() => {
            window.location.reload();
          });
          //window.location.href = 'r';
        }}
      >
        {/* <div
          style={{ font: 'normal normal normal 14px/1 FontAwesome !important' }}
          className='fa fa-refresh'
        ></div> */}
      </button>
      <button
        className='languagebutton'
        title='langdebutton'
        onClick={() => {
          window.location.href = '/de/de/';
        }}
      >
        <div className='flag-icon flag-icon-de'></div>
      </button>
      <button
        className='languagebutton'
        title='langenbutton'
        onClick={() => {
          window.location.href = '/us/en/';
        }}
      >
        <div className='flag-icon flag-icon-us'></div>
      </button>
    </div>
  );
}
